import React from "react";
import ComingSoon from "../../components/sections/Home/ComingSoon";

export default function Index() {
    return (
        <>
            <ComingSoon />
        </>
    );
}
